// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"96dcf2f4","453":"68eb482d"}[chunkId] + ".chunk.js";
};